import React, { useEffect } from 'react';

const PrivacyPolicy = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <div className="privacy-policy-container" style={{ padding: '20px', marginTop: '150px', maxWidth: '800px', margin: '0 auto', textAlign: 'left' }}>
                <h1 className='text-gradient'>Privacy Policy</h1>
                <p>At CLOUD MIND X, we are committed to protecting the privacy and confidentiality of our clients, partners, and website visitors. This Privacy Policy outlines how we collect, use, store, and safeguard your personal information when you access or use our website and services.</p>
                <p>By visiting or using our website, you agree to the terms, conditions, and practices described in this Privacy Policy.</p>

                <h2>Information We Collect</h2>
                <p>While interacting with our website, we may collect and process the following information:</p>

                <h3>Information About Your Website Visit</h3>
                <p>This includes details such as:</p>
                <ul>
                    <li>Pages viewed</li>
                    <li>Time spent on the website</li>
                    <li>Traffic and usage data</li>
                    <li>Location and device-related information</li>
                </ul>
                <p>This data helps us understand how users interact with our website and allows us to improve our services and user experience.</p>

                <h3>Information Voluntarily Provided by You</h3>
                <p>When you choose to share information with us, such as by filling out forms or submitting inquiries, we may collect:</p>
                <ul>
                    <li>Name</li>
                    <li>Email address</li>
                    <li>Phone number</li>
                    <li>Company details</li>
                    <li>Any other information you voluntarily provide</li>
                </ul>
                <p>This information is handled securely and strictly in accordance with our privacy standards.</p>

                <h3>Information Shared When You Contact Us</h3>
                <p>Any communication you have with CLOUD MIND X—via email, contact forms, or other channels—may involve sharing personal or business-related information. Such information is treated as confidential and used only for legitimate business purposes.</p>

                <h3>Payment Information</h3>
                <p>CLOUD MIND X does not store or retain any payment-related information, including credit card details, bank account information, or financial data. Payments, if any, are processed securely through authorized third-party payment gateways.</p>

                <h2>Use of Cookies</h2>
                <p>Our website may use cookies to collect non-personal information related to your browsing activity. Cookies help us:</p>
                <ul>
                    <li>Improve website functionality</li>
                    <li>Analyze website traffic</li>
                    <li>Enhance overall user experience</li>
                </ul>
                <p>The data collected through cookies is statistical in nature and does not personally identify users. You can choose to disable cookies through your browser settings; however, some features of the website may not function properly as a result.</p>

                <h3>Types of Cookies We Use</h3>
                <h4>Essential / Technical Cookies</h4>
                <p>These cookies are necessary for core website functionality such as form submissions, session management, and security features. Blocking these cookies may affect website performance.</p>

                <h4>Functional / Customization Cookies</h4>
                <p>These cookies allow us to remember user preferences and enhance personalized features. Disabling them may limit certain functionalities.</p>

                <h4>Performance Cookies</h4>
                <p>These cookies help us analyze website usage and improve performance by tracking visits and traffic sources.</p>

                <h4>Advertising & Behavioral Cookies</h4>
                <p>These cookies may be set by third-party partners to display relevant advertisements. If disabled, advertisements may be less personalized.</p>

                <h2>How We Use the Information Collected</h2>
                <p>We use your information for purposes including but not limited to:</p>
                <ul>
                    <li>Responding to inquiries and service requests</li>
                    <li>Providing information about our IT services and solutions</li>
                    <li>Communicating updates related to our website or services</li>
                    <li>Improving website performance and user experience</li>
                    <li>Sending promotional or informational content (only with your consent)</li>
                </ul>
                <p>You may withdraw your consent to receive marketing communications at any time.</p>

                <h2>Data Storage and Security</h2>
                <p>We take appropriate technical and organizational measures to protect your personal data from unauthorized access, misuse, or disclosure. However, please note that data transmitted over the internet cannot be guaranteed to be completely secure, and sharing information online is done at your own risk.</p>

                <h2>Disclosure of Information</h2>
                <p>We do not sell, rent, or trade personal information to third parties.</p>
                <p>We may share non-personal, aggregated data with trusted partners for analytics or business improvement purposes. Information may also be disclosed if required by law or legal authorities.</p>

                <h2>Third-Party Links</h2>
                <p>Our website may contain links to external third-party websites. CLOUD MIND X is not responsible for the privacy practices or content of such websites. Users are advised to review the privacy policies of external sites independently.</p>

                <h2>Embedded Social Media Features</h2>
                <p>Some pages may include social media sharing tools or embedded widgets. These features may collect data or use cookies according to the respective social media platform's privacy policy.</p>

                <h2>Changes to This Privacy Policy</h2>
                <p>CLOUD MIND X reserves the right to update or modify this Privacy Policy at any time. Any changes will be reflected by updating the effective date on this page. We encourage users to review this policy periodically to stay informed.</p>

                <h2>Acceptance of This Policy</h2>
                <p>By using our website, you acknowledge that you have read, understood, and agreed to this Privacy Policy. If you do not agree with any part of this policy, please discontinue use of our website. Continued use following updates signifies acceptance of the revised policy.</p>
            </div>
        </>
    );
};

export default PrivacyPolicy;
